import React from 'react';

export const createQServerFormFields = () => [
    {
        id: 'name',
        label: 'Name',
        name: 'name',
        type: 'text',
        helperText: 'Qlik Server Name',
        component: 'FormikTextField',
        xs: 12,
        sm: 6,
        md: 6,
    },
    {
        id: 'app',
        label: 'Qlik Sense App ID',
        name: 'app',
        type: 'text',
        component: 'FormikTextField',
        xs: 12,
        sm: 6,
        md: 6,
    },
    {
        id: 'tenantUri',
        label: 'Tenant URI',
        name: 'tenantUri',
        type: 'text',
        helperText: 'Example https://{Company Name}.eu.qlikcloud.com',
        component: 'FormikTextField',
        xs: 12,
        sm: 6,
        md: 6,
    },
    {
        id: 'webIntegrationId',
        label: 'Web Integration ID',
        name: 'webIntegrationId',
        type: 'text',
        helperText: 'Qlik Management Console - Integration - Web',
        component: 'FormikTextField',
        xs: 12,
        sm: 6,
        md: 6,
    },
    {
        id: 'secure',
        label: 'User Secure HTTPS',
        name: 'secure',
        type: 'text',
        component: 'FormikSelect',
        xs: 12,
        sm: 6,
        md: 6,
        items: [
            {
                value: 'YES',
                label: 'yes',
            },
            {
                value: 'NO',
                label: 'No',
            },
        ],
    },
    {
        id: 'port',
        label: 'Port',
        name: 'port',
        type: 'number',
        component: 'FormikTextField',
        xs: 12,
        sm: 6,
        md: 6,
    },
];
